export const testimonial = [
  {
    name: `As someone who's new to the city and trying to make friends, this app has been a lifesaver. It's so easy to connect with like-minded people and plan activities that suit our schedules.`,
    authod: "AMANDA NATJAN",
  },
  {
    name: `A game-changer for me and my friends. It's usually so difficult to find time to get together. This app makes it easy to plan and organize activities that work for everyone's schedules.`,
    authod: "AUSTIN CAMPBRLL",
  },
]
